import React from 'react';

import { ApolloError } from '@apollo/client';

import { SubmitOrderButton } from './SubmitOrderButton';
import { TaxImpactPreviewInfoBanner } from './TaxImpactPreviewInfoBanner';

import { DisplayableError } from '../../../../graphql/schema';
import { TaxImpactGainsAllowanceLoaded } from '../../../../Shared/Components/tax-impact-preview/gains-allowance/TaxImpactGainsAllowanceLoaded';
import { TaxImpactEstimateLoaded } from '../../../../Shared/Components/tax-impact-preview/tax-impact-estimate/TaxImpactEstimateLoaded';
import { TaxImpactGainLossLoaded } from '../../../../Shared/Components/tax-impact-preview/tax-impact-gain-loss/TaxImpactGainLossLoaded';
import { TaxImpactPreviewCard } from '../../../../Shared/Components/tax-impact-preview/TaxImpactPreviewCard';
import { CreateFinancialSecuritySellOrderTaxImpactPreviewMutation } from '../graphql/mutation.createFinancialSecuritySellOrderTaxImpactPreview.generated';
import { ReviewOrderError } from '../ReviewOrderError';

type TaxImpactPreviewData =
  CreateFinancialSecuritySellOrderTaxImpactPreviewMutation['createFinancialSecuritySellOrderTaxImpactPreview']['result'];

export type RequiredTaxImpactPreview = NonNullable<TaxImpactPreviewData> & {
  taxImpactPreview: NonNullable<NonNullable<TaxImpactPreviewData>['taxImpactPreview']>;
};

interface TaxImpactPreviewLoadedProps {
  onSubmit: () => void;
  hasActiveQueries: boolean;
  submitOrderDisplayableErrors?: DisplayableError[];
  submitOrderMutationError?: ApolloError;
  previewData: RequiredTaxImpactPreview;
}

export const TaxImpactPreviewLoaded: React.FC<TaxImpactPreviewLoadedProps> = ({
  onSubmit,
  hasActiveQueries,
  submitOrderDisplayableErrors,
  submitOrderMutationError,
  previewData,
}) => {
  const { taxImpactPreview, remainingGainsAllowance, gainsDetails } = previewData;

  return (
    <TaxImpactPreviewCard>
      <TaxImpactPreviewCard.DividedList>
        <TaxImpactEstimateLoaded netEstimatedTaxes={taxImpactPreview.netEstimatedTaxes} />
        <TaxImpactGainLossLoaded gainLoss={taxImpactPreview} variant="withWashSales" />
        {remainingGainsAllowance && gainsDetails && (
          <TaxImpactGainsAllowanceLoaded
            remainingGainsAllowance={remainingGainsAllowance}
            gainsDetails={gainsDetails}
          />
        )}
      </TaxImpactPreviewCard.DividedList>
      <TaxImpactPreviewInfoBanner />
      <SubmitOrderButton onClick={onSubmit} disabled={hasActiveQueries} />
      <ReviewOrderError
        submitOrderDisplayableErrors={submitOrderDisplayableErrors}
        submitOrderMutationError={submitOrderMutationError}
      />
    </TaxImpactPreviewCard>
  );
};
